export default "__VITE_ASSET__Bt_8OWX7__"